import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class FormDetailDto implements IFormDetailDto {
    employee!: EmployeeSummaryDto;
    address!: string | undefined;
    pan!: string | undefined;
    financialYear!: string | undefined;
    name!: string | undefined;
    schemaName!: string | undefined;
    underSectionGroupId!: number | undefined;
    underSectionId!: number | undefined;
    usGroupShortCode!: string | undefined;
    investmentId!: number | undefined;
    investment!: number | undefined;
    maxOtherAmount!: number | undefined;
    fromDate!: Date;
    toDate!: Date;
    assentmentYear!: string | undefined;
    companyLegalName!: string | undefined;
    companyPancard!: string | undefined;
    companyTancard!: string | undefined;
    companyAddress!: string | undefined;
    grossSalary!: number | undefined;
    standardDeduction!: number | undefined;
    professionalTax!: number | undefined;
    deductions!: number | undefined;
    aggregateValue!: number | undefined;
    loanAmount!: number | undefined;
    maxAllowLoanAmount!: number | undefined;
    loanGrossAmount!: number | undefined;
    investmentAmount!: number | undefined;
    maxInvestmentAmount!: number | undefined;
    otherInvestmentAmount!: number | undefined;
    totalInvestmentAmount!: number | undefined;
    rebateAmount!: number | undefined;
    totalIncome!: number | undefined;
    totalTax!: number | undefined;
    totalAmount!: number | undefined;
    totalITAmount!: number | undefined;
    totalSurchargeAmount!: number | undefined;
    totalEducationCessAmount!: number | undefined;
    finalAmount!: number | undefined;
    totalTDSDeductedAmount!: number | undefined;
    tdsFinalAmount!: number | undefined;

    constructor(data?: IFormDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.address = _data["address"];
            this.pan = _data["pan"];
            this.financialYear = _data["financialYear"];
            this.name = _data["name"];
            this.schemaName = _data["schemaName"];
            this.underSectionGroupId = _data["underSectionGroupId"];
            this.underSectionId = _data["underSectionId"];
            this.usGroupShortCode = _data["usGroupShortCode"];
            this.investmentId = _data["investmentId"];
            this.investment = _data["investment"];
            this.maxOtherAmount = _data["maxOtherAmount"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.assentmentYear = _data["assentmentYear"];
            this.companyLegalName = _data["companyLegalName"];
            this.companyPancard = _data["companyPancard"];
            this.companyTancard = _data["companyTancard"];
            this.companyAddress = _data["companyAddress"];
            this.grossSalary = _data["grossSalary"];
            this.standardDeduction = _data["standardDeduction"];
            this.professionalTax = _data["professionalTax"];
            this.deductions = _data["deductions"];
            this.aggregateValue = _data["aggregateValue"];
            this.loanAmount = _data["loanAmount"];
            this.maxAllowLoanAmount = _data["maxAllowLoanAmount"];
            this.loanGrossAmount = _data["loanGrossAmount"];
            this.investmentAmount = _data["investmentAmount"];
            this.maxInvestmentAmount = _data["maxInvestmentAmount"];
            this.otherInvestmentAmount = _data["otherInvestmentAmount"];
            this.totalInvestmentAmount = _data["totalInvestmentAmount"];
            this.rebateAmount = _data["rebateAmount"];
            this.totalIncome = _data["totalIncome"];
            this.totalTax = _data["totalTax"];
            this.totalAmount = _data["totalAmount"];
            this.totalITAmount = _data["totalITAmount"];
            this.totalSurchargeAmount = _data["totalSurchargeAmount"];
            this.totalEducationCessAmount = _data["totalEducationCessAmount"];
            this.finalAmount = _data["finalAmount"];
            this.totalTDSDeductedAmount = _data["totalTDSDeductedAmount"];
            this.tdsFinalAmount = _data["tdsFinalAmount"];
        }
    }

    static fromJS(data: any): FormDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["pan"] = this.pan;
        data["financialYear"] = this.financialYear;
        data["name"] = this.name;
        data["schemaName"] = this.schemaName;
        data["underSectionGroupId"] = this.underSectionGroupId;
        data["underSectionId"] = this.underSectionId;
        data["usGroupShortCode"] = this.usGroupShortCode;
        data["investmentId"] = this.investmentId;
        data["investment"] = this.investment;
        data["maxOtherAmount"] = this.maxOtherAmount;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["assentmentYear"] = this.assentmentYear;
        data["companyLegalName"] = this.companyLegalName;
        data["companyPancard"] = this.companyPancard;
        data["companyTancard"] = this.companyTancard;
        data["companyAddress"] = this.companyAddress;
        data["grossSalary"] = this.grossSalary;
        data["standardDeduction"] = this.standardDeduction;
        data["professionalTax"] = this.professionalTax;
        data["deductions"] = this.deductions;
        data["aggregateValue"] = this.aggregateValue;
        data["loanAmount"] = this.loanAmount;
        data["maxAllowLoanAmount"] = this.maxAllowLoanAmount;
        data["loanGrossAmount"] = this.loanGrossAmount;
        data["investmentAmount"] = this.investmentAmount;
        data["maxInvestmentAmount"] = this.maxInvestmentAmount;
        data["otherInvestmentAmount"] = this.otherInvestmentAmount;
        data["totalInvestmentAmount"] = this.totalInvestmentAmount;
        data["rebateAmount"] = this.rebateAmount;
        data["totalIncome"] = this.totalIncome;
        data["totalTax"] = this.totalTax;
        data["totalAmount"] = this.totalAmount;
        data["totalITAmount"] = this.totalITAmount;
        data["totalSurchargeAmount"] = this.totalSurchargeAmount;
        data["totalEducationCessAmount"] = this.totalEducationCessAmount;
        data["finalAmount"] = this.finalAmount;
        data["totalTDSDeductedAmount"] = this.totalTDSDeductedAmount;
        data["tdsFinalAmount"] = this.tdsFinalAmount;
        return data; 
    }
}

export interface IFormDetailDto {
    employee: EmployeeSummaryDto;
    address: string | undefined;
    pan: string | undefined;
    financialYear: string | undefined;
    name: string | undefined;
    schemaName: string | undefined;
    underSectionGroupId: number | undefined;
    underSectionId: number | undefined;
    usGroupShortCode: string | undefined;
    investmentId: number | undefined;
    investment: number | undefined;
    maxOtherAmount: number | undefined;
    fromDate: Date;
    toDate: Date;
    assentmentYear: string | undefined;
    companyLegalName: string | undefined;
    companyPancard: string | undefined;
    companyTancard: string | undefined;
    companyAddress: string | undefined;
    grossSalary: number | undefined;
    standardDeduction: number | undefined;
    professionalTax: number | undefined;
    deductions: number | undefined;
    aggregateValue: number | undefined;
    loanAmount: number | undefined;
    maxAllowLoanAmount: number | undefined;
    loanGrossAmount: number | undefined;
    investmentAmount: number | undefined;
    maxInvestmentAmount: number | undefined;
    otherInvestmentAmount: number | undefined;
    totalInvestmentAmount: number | undefined;
    rebateAmount: number | undefined;
    totalIncome: number | undefined;
    totalTax: number | undefined;
    totalAmount: number | undefined;
    totalITAmount: number | undefined;
    totalSurchargeAmount: number | undefined;
    totalEducationCessAmount: number | undefined;
    finalAmount: number | undefined;
    totalTDSDeductedAmount: number | undefined;
    tdsFinalAmount: number | undefined;
}

